<template>
  <div class="wallet-list-wrapper">
    <v-btn
      v-for="method in walletItemList"
      :key="method.code"
      class="wallet_item text-center"
      text
      color="primary"
      :class="{ selected: method.selected }"
      :loading="loadingBalance"
      @click="handleMethodClick(method)"
    >
      <img
        :src="require('@/assets/wallet/' + method.icon)"
        class="wallet_item_image"
        alt="Wallet images"
      />
    </v-btn>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { mapFields } from "vuex-map-fields";

  export default {
    name: 'WalletPaymentMethodsList',

    props: {
      estimate: {
        type: Number,
        default: 0
      }
    },

    data () {
      return {
        walletItemList: [
          { protocol: "Capitalist", code: "Capitalist", name: "Capitalist", icon: "capitalist.svg", selected: true },
          { protocol: "Alipay", code: "ALIPAYPLUS", name: "Alipay", icon: "alipay.svg", selected: false },
          { protocol: "Picpay", code: "PICPAY", name: "Picpay", icon: "picpay.svg", selected: false },
          { protocol: "Pix", code: "PIX", name: "Pix", icon: "pix.svg", selected: false },
        ],
        selectedMethodIndex: 0
      }
    },

    computed:{
      ...mapGetters({
        paymentInfo: 'plans/paymentInfo',
        loadingBalance: 'plans/loadingBalance',
        currentCase: 'plans/currentCase'
      }),
      ...mapFields('plans', ['invoice'])
    },

    created () {
      this.handleMethodClick(this.walletItemList[0])
    },

    methods: {
      handleMethodClick (method) {
        if (!method.selected) {
          this.walletItemList[this.selectedMethodIndex].selected = false

          const selectedMethodIndex = this.walletItemList.indexOf(method)

          this.walletItemList[selectedMethodIndex].selected = true
          this.selectedMethodIndex = selectedMethodIndex
        }

        this.invoice.currency = "USD"
        this.invoice.coin = method.code

        this.$store.dispatch('plans/setWallet', method.code)
      }
    }
  }
</script>

<style>
  .wallet-list-wrapper {
    display: flex;
    justify-content: center;
    gap: 6px;
    margin-top: 24px;
    width: 100%;
  }

  .wallet_item {
    min-width: 102px;
    flex: 1;
    height: 44px!important;
    border: 1px solid #E1E1E4;
    border-radius: 6px;
  }

  .wallet_item_image {
    max-width: 80px;
  }

  .selected {
    background: rgba(181, 71, 233, 0.1)!important;
    border: 1px solid #B547E9!important;
  }
</style>